
import {mergeMap} from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { AppService } from '../../commons/app.service';
import { FourDService,ProcessorAPI } from '4d-mapper';
import { MatSnackBar, MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { APITypes } from '../../commons/global';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {MapService} from '../../commons/map.service';

// generic helpers
import {Constants} from './../../commons/Constants';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

@Component({
    selector: 'integrations-comp',
    templateUrl: './integrations.component.html'

})
export class IntegrationsComponent extends AppBaseComponent implements OnInit, OnDestroy {

    error:string
    success:string
    //apis:ProcessorAPI[]     = []
    // sub:Subscription  ;; commented out as it's also defined in AppBaseComponent class

    apiTypes:string[]       = [,  APITypes.SDK.NAME, APITypes.Datum360.NAME, APITypes.Trackonus.NAME,  APITypes.Photoscan.NAME,  APITypes.CapturingReality.NAME,  APITypes.Agronomeye.NAME]
    availApiTypes:string[]  = []
    AGRONOMEYE =  APITypes.Agronomeye.NAME

    // our secret clipboard
    clipboardText:string = '';

    sdks:ProcessorAPI[] = []
    otherApis:ProcessorAPI[] = []

    constructor(public fourD:FourDService,public service:AppService,public router:Router,
        public snackBar: MatSnackBar, public dialog: MatDialog, private activeRoute:ActivatedRoute,
        public translate: TranslateService, public mapService: MapService, applicationEvents:XsApplicationEventsService){
        super(service, router, snackBar, dialog, applicationEvents)

        this.addSubscription( 'onActiveAccountReady', this.fourD.onActiveAccountReady().subscribe(s => {

            // Refresh available Apis
            this.refreshApis();

        }));
    }

    onReady() {
        this.sdks = this.fourD.apis.filter(ap => ap.processorImpl == 'SDK' && ap.account.id == this.fourD.activeTeam.id)
        this.otherApis = this.fourD.apis.filter(ap => ap.processorImpl != 'SDK' && ap.account.id == this.fourD.activeTeam.id)
    }

    refreshApis() {
        this.availApiTypes = [APITypes.SDK.NAME]
        // Refresh available apis to be created.
        //this.apiTypes.forEach(a => {
        //    if ( !this.hasApiByType(a) ) this.availApiTypes.push(a)
        //});
        // hide HangOn / waiting box (if open)
        Constants.hideHangOn();
    }

    hasApiByType(type:string) {
        // If no apis then return false
        if (!this.fourD.apis) return false
        var res = false
        // Go through apis list and search for the type
        for (var i=0; i < this.fourD.apis.length; i++) {
            if (this.fourD.apis[i].type == type) {
                res = true
                break
            }
        }
        return res
    }

    copyToClipboard(inputElement){
        
        // get the value
        let val = inputElement.value;

        // find the clipboard
        let cb = <HTMLInputElement> document.getElementById('clipboard');

        // transfer values
        cb.value = val;
        this.clipboardText = val;

        // select the clipboard field, and make a copy
        cb.select();
        document.execCommand('copy');

        // select back to the original field
        inputElement.select();
        inputElement.setSelectionRange(0, 0);

        // assume success
        this.openSnackBarSuccess('GENERIC.COPIED')
    }

    saveApi(api:ProcessorAPI) {
        api.saveObservable().pipe(mergeMap(res => {
            return this.fourD.activeTeam.enableDisableApi(api.type, true)
        })).subscribe(
                succ => this.openSnackBarSuccess("API.SAVE_SUCC")
                ,err => this.openSnackBarError("ERROR.VASAT", "", err)
            )
    }

    deleteApi(api:ProcessorAPI, index:number) {
        this.openDialog('GENERIC.CONFIRM','API.DEL_CONF','GENERIC.YES','GENERIC.CANCEL').subscribe(s => {
            if(s){
                api.destroyObservable().pipe(
                    mergeMap(res=> {
                        return this.fourD.activeTeam.enableDisableApi(api.type, false)
                    })).subscribe(
                        succ=> {
                            this.fourD.apis.splice(index, 1)
                            this.sdks = this.sdks.filter(s => s != api)
                            // refresh new api pull down
                            this.refreshApis()
                            this.openSnackBarSuccess("API.DEL_SUCC")
                        },
                        err=> this.openSnackBarError("ERROR.VASAT", "", err)
                    )
            }
        }
            
        )
        
    }

    addApi(apiType:string) {
        // Create the new api object
        let newApi = new ProcessorAPI(this.service.V).set({type:apiType, processorImpl:APITypes[apiType].IMPL })
        // Specify default name if not ProcessorAPI
        if (apiType != APITypes.ProcessorAPI.NAME) newApi.name = apiType
        if(apiType == 'Photoscan' || apiType == 'CapturingReality' || apiType == 'SDK'){
            newApi.saveObservable().subscribe(s => {
                 this.fourD.apis.push(newApi)
                 if(apiType == 'SDK')
                    this.sdks.push(newApi)
            })
        }
        else{
            // push to the current list of apis
            this.fourD.apis.push(newApi)
        }
        // refresh new api pull down
        this.refreshApis()
    }

    testAPI(apiType:ProcessorAPI){
        apiType.saveObservable().subscribe(_ =>
            this.fourD.V.api('/remote/' + apiType.id + '/test').subscribe(s =>
                this.openSnackBarSuccess('GENERIC.CONNECT_OK')
                ,e =>

                this.openSnackBarError('GENERIC.CONNECT_ERROR2 '+ e)
            )
        )
    }
}
